<nz-table #table mm-table [pagedData]="pagedData">
    <ng-content>

    </ng-content>
  
</nz-table>